import axios from "axios";
import {accountUtils, userUtils} from "../utils";
import {CLOUDINARY_ID} from "../constants";

export const joinAccount = (user, code, success, failure) => {
    // need to skip the request interceptors (don't want to redirect to login on 401)
    const instance = axios.create();
    const url = "/api/v1/account/join";

    instance.post(url, {
        user: {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            phone: user.phone,
            password: user.password,
        },
        code: code,
    })
    .then(response => {
        const json = response.data;

        accountUtils.sanitizeAccount(json.account);
        userUtils.sanitizeUser(json.user);

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const joinAdditionalAccount = (code, success, failure) => {
    axios.put("/api/v1/account/joinAdditional", {
        code: code,
    })
    .then(response => {
        const json = response.data;

        accountUtils.sanitizeAccount(json.account);
        userUtils.sanitizeUser(json.user);

        success(json);
    })
    .catch(failure);
};

export const loadMyAccount = (success, failure) => {
    axios.get("/api/v1/account/")
    .then(response => {
        const json = response.data;

        accountUtils.sanitizeAccount(json);

        success(json);
    })
    .catch(failure);
};

export const saveMyAccount = (account, success, failure) => {
    axios.put("/api/v1/account/", {
        name: account.name,
        website: account.website,
        branding: accountUtils.standardizeBranding(account.branding),
        allowJoin: account.allowJoin,
        settings: account.settings,
    })
    .then(response => {
        const json = response.data;

        accountUtils.sanitizeAccount(json);

        success(json);
    })
    .catch(failure);
};

export const uploadImage = function(accountId, logo, success, failure) {
    const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY_ID}/upload`;

    const data = new FormData();
    data.append("upload_preset", "account_image");
    data.append("file", logo);
    data.append("tags", accountId);

    // need to skip the request interceptors (don't want to include the JWT)
    const instance = axios.create();

    instance.post(url, data, {
        headers: {
            "X-Requested-With": "XMLHttpRequest",
        },
    })
    .then(response => {
        success(response.data.secure_url);
    })
    .catch(failure);
};
